module.exports = __webpack_public_path__ + "static/media/undraw_blog_anyj.be59aace.svg";